import { motion } from "framer-motion";

const STATS = [
  { n: "187", l: "Projets livrés depuis 2014" },
  { n: "28 j", l: "Délai moyen d'avant-projet" },
  { n: "10 ans", l: "Garantie décennale" },
  { n: "32", l: "Artisans signature partenaires" },
];

export default function Stats() {
  return (
    <section data-testid="stats-section" className="bg-bone border-y border-ink/15">
      <div className="container-max grid grid-cols-2 md:grid-cols-4">
        {STATS.map((s, i) => (
          <motion.div
            key={s.l}
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: i * 0.08 }}
            className="py-12 md:py-16 px-4 md:px-8 border-r border-ink/10 last:border-r-0 [&:nth-child(2)]:border-r-0 md:[&:nth-child(2)]:border-r"
          >
            <div className="font-display text-5xl md:text-7xl text-ink leading-none">{s.n}</div>
            <p className="overline mt-4">{s.l}</p>
          </motion.div>
        ))}
      </div>
    </section>
  );
}
